export default {
  format(date) {
    if (!date) return
    const dateModel = new Date(date)
    let month = (dateModel.getMonth() + 1).toString()
    let day = dateModel.getDate().toString()

    if (month.length < 2) {
      month = `0${month}`
    }
    if (day.length < 2) {
      day = `0${day}`
    }

    return `${dateModel.getFullYear()}-${month}-${day}`
  },
  isSameDay(date1, date2) {
    date1 = date1 ? new Date(date1) : null
    date2 = date2 ? new Date(date2) : null

    return date1 === date2
        || date1 && date2
        && date1.getFullYear() === date2.getFullYear()
        && date1.getMonth() === date2.getMonth()
        && date1.getDate() === date2.getDate()
  },
  subtract(value, date = null) {
    date = date ? new Date(date) : new Date()
    date.setDate(date.getDate() - value)
    return date
  }
}
